import { Menu } from 'semantic-ui-react';

import RouteNavItem from '../../RouteNavItem';
import { SIGN_IN_LABEL } from '../MainHeader.constants';

const SignInMenu = () => {
  return (
    <Menu>
      <Menu.Menu position='right'>
        <RouteNavItem to='/login'>{SIGN_IN_LABEL}</RouteNavItem>
      </Menu.Menu>
    </Menu>
  );
};

export default SignInMenu;
